import axios from 'axios';
//import { Auth } from 'aws-amplify/auth';
import {Amplify} from 'aws-amplify';
import {fetchUserAttributes, getCurrentUser} from 'aws-amplify/auth';
import {fetchAuthSession} from 'aws-amplify/auth';
import {ApiException} from '../../logging/api/api-exception/apiException';
import getCatalyticsApiUrl from '../../../../data/Urls';
import {useState} from 'react';

let advertiserResponse = {
    status: false,
    error: '',
    info: {},
};

const CreateAdvertiser = async () => {
    let accessTokenStr = undefined;
    const {username, userId, signInDetails} = await getCurrentUser();
    const currentUserInfo = await fetchUserAttributes();
    //const token = (await Auth.currentSession()).getAccessToken().getJwtToken();
    try {
        const {accessToken, idToken} = (await fetchAuthSession()).tokens ?? {};
        accessTokenStr = accessToken.toString();
    } catch (err) {
        console.log(err);
    }
    let request = {}
    let email = ''
    if (currentUserInfo === undefined) {
        email = signInDetails['loginId'];
        request = {
            firstName: username,
            lastName: '',
            companyName: '',
            emailAddress: signInDetails['loginId'],
        };
    } else {
        email = currentUserInfo['email'];
        request = {
            firstName: currentUserInfo['given_name'],
            lastName: currentUserInfo['family_name'],
            companyName: currentUserInfo['custom:Company'],
            emailAddress: currentUserInfo['email'],
        };
    }
    await axios
        .post(
            getCatalyticsApiUrl() + 'create-advertiser',
            {
                body: JSON.stringify(request),
            },
            {
                headers: {
                    Authorization: `Basic ${accessTokenStr}`,
                    'Content-Type': 'application/json',
                },
            }
        )
        .then(async (responseCreate) => {
            if (
                responseCreate.data === undefined ||
                responseCreate.data.body === undefined
            ) {
                advertiserResponse.error = 'Empty response from POST create advertiser';
                ApiException(
                    advertiserResponse.error,
                    {email: email},
                    request,
                    responseCreate
                );
                return;
            }
            let responseBody = JSON.parse(responseCreate.data.body);
            if (
                responseBody['status'] === undefined ||
                responseBody['status'] !== 'OK' ||
                responseBody['id'] === undefined ||
                responseBody['id'] === ''
            ) {
                advertiserResponse.error =
                    'Error response from POST create advertiser (false status or missing id)';
                ApiException(
                    advertiserResponse.error,
                    {email: email},
                    request,
                    responseCreate
                );
                return;
            }
            advertiserResponse.status = true;
            advertiserResponse.info = responseBody;
        })
        .catch(function (error) {
            advertiserResponse.error = error;
            ApiException(
                advertiserResponse.error,
                {email: email},
                request,
                {}
            );
        });
    return advertiserResponse;

};

export default CreateAdvertiser;
